export const locale = {
  lang: 'de',
  data: {
    BITSO: {
      AWESOME: 'Erstelle Awesome 🙌',
      BITSO: 'Verwaltung von Krypto-Assets auf Bitso',
      BITSO_ACCOUNT_DETAILS: 'Kontodetails',
      BITSO_CRYPTO_ASSETS: 'Krypto-Vermögenswerte',
      BITSO_CRYPTO_QUOTES: 'Krypto-Kurse',
      BITSO_THE_PURCHASE_WAS_COMPLETED_SUCCESSFULLY: 'Der Kauf wurde erfolgreich abgeschlossen.',
      BITSO_SUCCESS: 'Erfolg',
      BITSO_ERROR: 'Fehler',
      BITSO_COMMUNICATION_ERROR: 'Kommunikationsfehler',
      GET_BALANCE: 'Guthaben abrufen',
      GET_QUOTE: 'Angebot einholen',
      CONFIRM_PURCHASE: 'Kauf bestätigen',
      GET_CUSTOMER_INFORMATION: 'Kundendaten abrufen'
    }
  }
}
